import { actions } from './actions';

const INITIAL_STATE = {
  projects: null,
  currentProject: {},
  currentProjectLoading: true,
  addProjectModal: false,
  shareProjectModal: false,
};

export default function projectsReducer(
  state = INITIAL_STATE,
  { type, payload },
) {
  switch (type) {
    case actions.RESET:
      return INITIAL_STATE;
    case actions.ALL_PROJECTS_SUCCESS:
      return { ...state, projects: payload };
    case actions.PROJECT_SUCCESS:
      return { ...state, currentProject: payload };
    case actions.TOGGLE_CURRENT_PROJECT_LOADING:
      return { ...state, currentProjectLoading: payload };
    case actions.TOGGLE_ADD_PROJECT_MODAL:
      return { ...state, addProjectModal: payload };
    case actions.TOGGLE_SHARE_PROJECT_MODAL:
      return { ...state, shareProjectModal: payload };
    default:
      return state;
  }
}
